const NAME = 'mitsubishi';

export const isMitsubishi = (token) => {
  return token && token.includes(NAME);
};
